import script from "./InputWithContextMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputWithContextMenu.vue?vue&type=script&setup=true&lang=ts"

import "./InputWithContextMenu.vue?vue&type=style&index=0&id=88c56698&lang=scss&scroped=true"

const __exports__ = script;

export default __exports__